import reduceReducers from 'reduce-reducers';
import { initializeActions } from '@tmosystems/core';

// Reducers
import baseReducer from './baseReducer';
import customReducer from './customReducer';

// Action creators
import {
  // Async action creators
  NEWS__CREATE_STORY,
  NEWS__CREATE_AND_PUBLISH_STORY,
  NEWS__GET_STORY,
  NEWS__UPDATE_STORY,
  NEWS__UPDATE_AND_PUBLISH_STORY,
  NEWS__PUBLISH_STORY,
  NEWS__UNPUBLISH_STORY,
  NEWS__DELETE_STORY,
  NEWS__PIN_STORY,
} from './actionCreators';

export const initialState = {
  stories: {
    instance: {},
    instances: [],
    selected: [],
    selectedIndices: [],
    modalMeta: {
      isOpen: false,
      openMode: 'create',
    },
    tableMeta: {
      page: 0,
      rowsPerPage: 10,
    },
    scrollMeta: {
      page: 0,
      size: 24,
      noMoreInstances: false,
    },
    searchMeta: {
      searchTerm: '',
    },
  },
  selectedCategory: -1,
  actions: initializeActions([
    NEWS__CREATE_STORY,
    NEWS__CREATE_AND_PUBLISH_STORY,
    NEWS__GET_STORY,
    NEWS__UPDATE_STORY,
    NEWS__UPDATE_AND_PUBLISH_STORY,
    NEWS__PUBLISH_STORY,
    NEWS__UNPUBLISH_STORY,
    NEWS__DELETE_STORY,
    NEWS__PIN_STORY,
  ]),
};

export default reduceReducers(initialState, baseReducer, customReducer);
